module.exports = __webpack_public_path__ + "static/media/finger_register_green.62750aba.svg";